(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var ShadowPhone = (function() {
			var __private = {
				prefix: "",
				mask: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],

				set(input) {
					if(input.tagName !== "INPUT" || input.type !== "tel") throw new Error("This element is not input 'tel'");
					
					this.mainForm = input.form;
					this.mainName = input.name;
					this.defValue = input.value;

					this.createInput();
					this.listener(input);
				},

				createInput() {
					this.hidden = document.createElement("input");
					this.hidden.type  = "hidden";
					this.hidden.name  = this.mainName;
					this.hidden.value = this.prefix + this.clean(this.defValue);

					//console.log(this.hidden.value);

					//this.mainForm.appendChild(this.hidden);
					if(this.mainForm instanceof HTMLFormElement)
						this.mainForm.insertBefore(this.hidden, this.mainForm.firstElementChild);
				},

				searchInput(name) {
					var hiddens = document.querySelectorAll("input[type=hidden]");

					for(let i = 0; i < hiddens.length; i++) {
						if(hiddens[i].name === name) return hiddens[i];
					}
				},

				listener(input) {
					input.addEventListener("keyup", function() {
						var val = this.value;
						var hiddenVal = __private.prefix + val;
						var hidd = __private.searchInput(this.name);

						hidd.value = __private.clean(hiddenVal);
					});
				},

				clean(string) {
					var newString = "";

					for(let i = 0; i < string.length; i++) {
						let letter = string[i];

						if(letter != undefined) {
							for(let j = 0; j < this.mask.length; j++) {
								if(letter == this.mask[j]) {
									newString += letter;
									break;
								}
							}
						}
					}

					return newString;
				}
			};

			return {
				create(input) {
					__private.set(input);
				}
			};
		})();


		var phones = document.querySelectorAll("input[type=tel]");
		if(phones.length !== 0) {
			for(let i = 0; i < phones.length; i++) {

				//console.log(phones[i]);
				//console.log(phones[i].value);

				ShadowPhone.create(phones[i]);
			}
		}

	});
})();